import { inspect } from 'util';

export function serializeError(e: unknown): string {
  return inspect(e, { depth: 8, breakLength: Infinity });
}
